import { Button, SuperEllipse, Typography } from '@themenu/design-system'
import Link from 'next/link'
import { logger } from 'lib/analytics/logger'
import React, { ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logger.error(error.message || 'ClientSide Error', { errorInfo }, error)
  }

  handleRetry = () => {
    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full h-screen flex flex-col justify-center items-center">
          <div className="flex flex-col gap-16 items-center justify-center bg-white-100 px-32 py-64 rounded-16 border border-border-default w-full max-w-4xl ">
            <SuperEllipse icon="ghost" colorSet="critical" size={96} />

            <div className="flex gap-4">
              <Typography variant="h1" className="text-content-critical">
                Ops!
              </Typography>
              <Typography variant="h1" className="text-content-subdued">
                Ocorreu um erro inesperado.
              </Typography>
            </div>

            <Typography variant="body" className="text-content-default">
              Tente novamente ou entre em contato com o time de suporte.
            </Typography>

            <div className="flex flex-wrap gap-8 justify-center items-center mt-16">
              <Button variant="secondary" onClick={this.handleRetry}>
                Tentar novamente
              </Button>

              <Link href="/">
                <Button endIcon="home">Ir para a home</Button>
              </Link>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
